import { Empty, Typography, Flex } from 'antd';
import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';
import { ReactComponent as NoDataWhiteSvg } from '../../assets/no-data-white.svg';
import { ReactComponent as NoDataDarkSvg } from '../../assets/no-data-black.svg';
import './EmptyCard.css';
import { useTheme } from '../../context/ThemeContext';
import { DARK } from '../../utilities/constants';

const { Text } = Typography;

const EmptyCard = ({
  image = null,
  description = <Text>No data to show.</Text>,
  customStyle = {},
  selectedRow = false,
}) => {
  const { theme } = useTheme();

  return (
    <Flex
      justify="center"
      align="center"
      className="full-height full-width default-empty-state"
      style={customStyle}
    >
      <Empty
        image={
          image === null ? (
            <Icon
              component={
                selectedRow
                  ? theme === DARK
                    ? NoDataWhiteSvg
                    : NoDataDarkSvg
                  : theme === DARK
                    ? NoDataDarkSvg
                    : NoDataWhiteSvg
              }
            />
          ) : (
            image
          )
        }
        description={description}
      />
    </Flex>
  );
};

EmptyCard.propTypes = {
  image: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  customStyle: PropTypes.object,
};

export default EmptyCard;
